// initMobileMenu.js (ES5)
export default function initMobileMenu() {
  var body = document.body;
  var openBtn = document.querySelector('.js-menu-open');
  var menu = document.getElementById('mobile-menu');
  if (!openBtn || !menu) return;

  var closeBtns = menu.querySelectorAll('.js-menu-close');
  var focusables = null;
  var lastActiveEl = null;

  function setAria(open) {
    openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function openMenu() {
    if (body.classList.contains('is-menu-open')) return;

    lastActiveEl = document.activeElement;
    body.classList.add('is-menu-open');
    setAria(true);

    // bloquear scroll del body (simple y efectivo)
    body.style.overflow = 'hidden';

    // focus management básico
    focusables = menu.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
    if (focusables.length) focusables[0].focus();
  }

  function closeMenu() {
    if (!body.classList.contains('is-menu-open')) return;

    body.classList.remove('is-menu-open');
    setAria(false);

    body.style.overflow = '';

    if (lastActiveEl && lastActiveEl.focus) lastActiveEl.focus();
  }

  openBtn.addEventListener('click', function () {
    openMenu();
  });

  for (var i = 0; i < closeBtns.length; i++) {
    closeBtns[i].addEventListener('click', function () {
      closeMenu();
    });
  }

  // Cerrar con ESC
  document.addEventListener('keydown', function (e) {
    var key = e.key || e.keyCode;
    if (key === 'Escape' || key === 'Esc' || key === 27) closeMenu();
  });

  // Cerrar al hacer click en un link del menú
  menu.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a) return;
    closeMenu();
  });

  // Si vuelves a >1200, cerramos por si acaso
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 1200) closeMenu();
  });
}
